if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.mobileVerticalThumbs = this.dataset.mobileThumbnailsVertical === 'true';
        if (window.BirtzApplyGalleryLanguage) window.BirtzApplyGalleryLanguage(this);
        this.bindGalleryNav();
        this.bindGallerySwipe();
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        if (window.BirtzApplyGalleryLanguage) window.BirtzApplyGalleryLanguage(this, false);
        const slides = this.visibleSlides();
        const requested = slides.find((slide) => slide.dataset.mediaId === mediaId);
        const activeMedia = requested || slides[0];
        if (!activeMedia) {
          return;
        }
        this.slideElements().forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');
        if (activeMedia.parentElement) activeMedia.parentElement.scrollLeft = 0;

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails && this.dataset.swapFeature !== 'true') {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);
        this.updateGalleryNav();

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${activeMedia.dataset.mediaId}"]:not(.is-lang-hidden)`
        );
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.dataset.swapFeature === 'true') {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((item) => {
            item.classList.toggle('is-current-feature', item === thumbnail);
          });
          return;
        }

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        if (this.mobileVerticalThumbs && !this.mql.matches) {
          this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
        } else {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      bindGalleryNav() {
        this.navPrev = this.querySelector('[data-gallery-nav="prev"]');
        this.navNext = this.querySelector('[data-gallery-nav="next"]');
        if (!this.navPrev || !this.navNext) return;

        this.navPrev.addEventListener('click', (event) => {
          event.preventDefault();
          this.stepGallery(-1);
        });
        this.navNext.addEventListener('click', (event) => {
          event.preventDefault();
          this.stepGallery(1);
        });
        this.updateGalleryNav();
      }

      slideElements() {
        if (!this.elements.viewer) return [];
        return Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'));
      }

      visibleSlides() {
        return this.slideElements().filter((slide) => !slide.classList.contains('is-lang-hidden'));
      }

      stepGallery(direction) {
        const slides = this.visibleSlides();
        if (slides.length < 2) return;

        let currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (currentIndex < 0) currentIndex = 0;
        const nextIndex = (currentIndex + direction + slides.length) % slides.length;

        const target = slides[nextIndex];
        if (!target || !target.dataset.mediaId) return;
        this.setActiveMedia(target.dataset.mediaId, false);
      }

      bindGallerySwipe() {
        const viewer = this.elements.viewer;
        if (!viewer || viewer.dataset.swipeBound === 'true') return;
        viewer.dataset.swipeBound = 'true';

        let startX = 0;
        let startY = 0;
        let tracking = false;

        viewer.addEventListener(
          'touchstart',
          (event) => {
            if (!event.touches || event.touches.length !== 1) return;
            if (event.target.closest('.product-gallery-arrow, .custom-coll')) return;
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
            tracking = true;
          },
          { passive: true }
        );

        viewer.addEventListener(
          'touchend',
          (event) => {
            if (!tracking) return;
            tracking = false;
            if (!this.mobileVerticalThumbs || window.matchMedia('(min-width: 750px)').matches) return;

            const touch = event.changedTouches && event.changedTouches[0];
            if (!touch) return;

            const deltaX = touch.clientX - startX;
            const deltaY = touch.clientY - startY;
            if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

            this.swiped = true;
            this.stepGallery(deltaX < 0 ? 1 : -1);
          },
          { passive: true }
        );

        viewer.addEventListener(
          'click',
          (event) => {
            if (!this.swiped) return;
            this.swiped = false;
            event.preventDefault();
            event.stopPropagation();
          },
          true
        );
      }

      updateGalleryNav() {
        const slides = this.visibleSlides();
        const currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const current = this.querySelector('.slider-counter--current');
        const total = this.querySelector('.slider-counter--total');

        if (current) current.textContent = String(currentIndex >= 0 ? currentIndex + 1 : 1);
        if (total) total.textContent = String(slides.length);

        if (!this.navPrev || !this.navNext) return;

        const hide = slides.length < 2;
        this.navPrev.hidden = hide;
        this.navNext.hidden = hide;
        this.navPrev.disabled = hide;
        this.navNext.disabled = hide;
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
